module.exports = __webpack_public_path__ + "static/media/Raleway-ExtraLight.550ad10f.ttf";